import { useCallback, useEffect, useState } from 'react';
import { tradeService } from '../services/trade-service';

/**
 * Contadores de Trade Intelligence para el menú lateral.
 *
 * La idea es que lo accionable se vea **sin entrar**: cuántas cotizaciones
 * esperan respuesta y cuántas tarifas están vencidas. Un menú que solo lista
 * secciones obliga a entrar a cada una para saber si hay algo que hacer.
 *
 * Falla en silencio a propósito: si el backend no responde, el menú se dibuja
 * sin contadores. Un contador roto no debe romper la navegación.
 */

export interface TradeCounters {
  /** Tarifas vencidas — accionable, se pinta en ámbar. */
  expiredRates: number;
}

/** Cada cuánto se refrescan, en milisegundos. */
const REFRESH_MS = 5 * 60 * 1000;

export function useTradeCounters(enabled: boolean): TradeCounters {
  const [counters, setCounters] = useState<TradeCounters>({ expiredRates: 0 });

  const load = useCallback(async () => {
    try {
      const status = await tradeService.getTariffStatus();
      setCounters({ expiredRates: status.expiredRates });
    } catch {
      // Sin permiso o sin red: el menú va sin contadores.
      setCounters({ expiredRates: 0 });
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    void load();
    const timer = setInterval(() => void load(), REFRESH_MS);
    return () => clearInterval(timer);
  }, [enabled, load]);

  return counters;
}
